import React from 'react'
import Modal from 'react-bootstrap/Modal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
const EditRegModal = ({ show, handleClose }) => {
    const BillOpt = [{ value: 'AE Console Bill', label: 'AE Console Bill' },
    { value: 'AI Console Bill', label: 'AI Console Bill' },
    { value: 'Air Export Invoice', label: 'Air Export Invoice' },];
    const BillToOpt = [{ value: 'Direct', label: 'Direct' },
    ]
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Registration</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Registration <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-2">
                            <label htmlFor="name" className='form-label'>
                                Registration No
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="SCAC"
                                name="SCAC"

                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Branch <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-2">
                            <div className="mb-2 ">
                                <div className="mb-1 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                        Unregistered
                                    </label>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-12 mb-2">
                            <label htmlFor="name" className='form-label'>
                                Registration Date
                            </label>
                            <input
                                type="date"
                                className="form-control form-control-sm w-100"
                                id="SCAC"
                                name="SCAC"

                            />
                        </div>
                        <div className="col-md-12 mb-2">
                            <label htmlFor="name" className='form-label'>
                                Valid Upto
                            </label>
                            <input
                                type="date"
                                className="form-control form-control-sm w-100"
                                id="SCAC"
                                name="SCAC"

                            />
                        </div>

                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Update
                        </button>

                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Cancel
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>

    )
}

export default EditRegModal